<template>
    <v-sheet color="primary lighten-2" :height="'calc(100vh - ' + $vuetify.application.top + 'px)'">
        <div v-if="snackbar?.on">
          <snackbar />
        </div>
        <div v-if="!promo">
            <v-container fluid class="pt-12">
                <v-row align-content="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card 
                            class="py-12 px-6 text-center mx-auto"
                            elevation="6"
                            max-width="400"
                            width="100%"
                        >
                            <h3 class="text-h6 mb-4">Verify Your Promocode</h3>

                            <v-sheet color="surface">
                            <v-otp-input
                                v-model="otp"
                                length="6"
                                type="text"
                                variant="solo"
                            ></v-otp-input>
                            </v-sheet>

                            <v-btn 
                                class="text-capitalize my-4"
                                color="primary"
                                height="35"
                                width="80%"
                                @click="checkPromo">
                                Verify
                            </v-btn>

                            <div class="text-caption">
                                Didn't receive the code? <a href="/" @click.prevent="otp = ''">Resend</a>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
            <v-container fluid class="pt-12">
                <v-row align-content="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card class="pb-4">
                            <v-toolbar dark flat color="primary">
                                <v-toolbar-title>Registration</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon color="white"
                                            v-on="on"
                                            to="/">
                                            <v-icon>mdi-close-circle</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ 'close' | localize }}</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                                <v-divider />
                                <v-form v-model="valid" ref="form" lazy-validation>
                                    <v-text-field color="primary" 
                                        :label="'Name' | localize" 
                                        name="name" 
                                        prepend-icon="mdi-account" 
                                        type="text"
                                        v-model="name" 
                                        :rules="[rules.required]">
                                    </v-text-field>
                                
                                    <v-text-field 
                                        prepend-icon="mdi-phone"
                                        :label="'Phone' | localize"
                                        color="primary" placeholder="+373 625-820-54"
                                        v-model="phone"
                                        :rules="[rules.required, rules.phone]">
                                    </v-text-field>
                                
                                    <v-text-field color="primary" 
                                        :label="'Email' | localize" 
                                        name="email" 
                                        prepend-icon="mdi-email" 
                                        type="text"
                                        v-model="email" 
                                        :rules="[rules.email, rules.required]">
                                    </v-text-field>
                                
                                    <v-text-field color="primary" 
                                        :label="'Password' | localize" 
                                        name="password" 
                                        prepend-icon="mdi-lock"
                                        :hint="'min 6 characters' | localize"
                                        minlength="6"
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show ? 'text' : 'password'"
                                        v-model="password"
                                        :rules="[rules.required, rules.min]"
                                        @click:append="show = !show">
                                    </v-text-field>

                                </v-form> 
                            </v-card-text>

                            <v-card-actions class="mt-4">
                                <v-spacer></v-spacer>
                                <v-btn small outlined 
                                    class="text-capitalize mb-4 mr-4" 
                                    color="primary" 
                                    @click="onSubmit" 
                                    :loading="loading"
                                    :disabled="!valid || loading">
                                    {{ 'confirm' | localize }}
                                </v-btn>
                            </v-card-actions>                 
                            <v-row class="error--text">{{ this.error }}</v-row>
                            <v-divider></v-divider>
                            <div class="text-left my-2 ml-2">
                                <span class="caption ml-2">
                                    {{ 'Already have an account' | localize }}?
                                </span>
                                <v-btn small text class="text-capitalize" color="primary" to="/login" :loading="loading">
                                    {{ 'Sign In' | localize }}
                                </v-btn>
                            </div>
                    </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-sheet>
</template>
<script>
import Snackbar from '../layouts/Snackbar.vue'
import localizeFilter from '../filters/localize.filter'

	export default {
		data() {
            return {
                email: '',
                password: '',
                name: '',
                phone: '',
                valid: false,
                show: false,
                error: '',
                otp: '',
                rules: {
                    required: value => !!value || localizeFilter('required field'),
                    min: v => v.length >= 6 || localizeFilter('min 6 characters'),
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || localizeFilter('invalid e-mail')
                    },
                    phone: value => {
                        const pattern = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
                        return pattern.test(value) || localizeFilter('invalid phone')
                    },
                }
            }
		},
        computed: {
            loading () {
                return this.$store.getters.loading;
            },
            snackbar() {
                return this.$store.getters.snackbar;
            },
            promo() {
                return this.$store.getters.promo;
            },
            user() {
                return this.$store.getters.user;
            },
        },
		methods: {
            gotoHome () {
                this.$router.replace('/')
            },
            dateLocale(date) {
                if (date) {
                    return new Date(date).toLocaleDateString();
                }
                return 'no date'
            },
            checkPromo() {
                console.log(this.otp)
            },
			async onSubmit (){
                const user = {}

				if (this.$refs.form.validate()) {
                    user.name = this.name
                    user.phone = this.phone
                    user.email = this.email
                    user.password = this.password
                    user.code = this.promocode
				}
				//console.log(user)
                try {
                   await this.$store.dispatch('registration', user);

                    if (this.user) {
                            this.$store.dispatch('showSnackbar', {
                            on: true,
                            color: 'secondary',
                            text: `${user.name}, your accont created successfuly`,
                            timeout: 2000
                        })
                    
                        setTimeout(() => {
                            //reset props
                            this.$refs.form.$reset();

                            this.valid = false
                            this.show = false
                            this.dialog = false

                            this.$router.replace('/signin')
                        }, 1500)
                    }
                    else {
                        this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `something wrong with user ${user.name}`,
                        timeout: 3000
                    })
                    }
                }
                catch(error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `${error.response.data.message}`,
                        timeout: 3000
                    })
                }                      
			},
		},
        components: {Snackbar}
	}
</script>